module.exports = __webpack_public_path__ + "static/img/1559.e715892.png";